<template>
  <div v-if="team" class="fantasy-create-team">
    <div class="box">
      <loading-state :state="state"></loading-state>
      <div  v-if="state.isLoaded()"  class="">
        <div class="box-header">
          <div class="main">
            <div class="buyin">
              <div class="line-1">
                <div class="rule-buyin">
                  ⨗{{(team.rule.buy_in_chips === 0)? 'FREE' : team.rule.buy_in_chips}}
                  <label>Buy In</label> 
                </div>
                <div class="rewards-first">
                  Gold Medal
                  <label>1st Price</label>
                </div>
              </div>
            </div>
            <div class="name" v-if="team.contestMatch.contest.name">Creating team for {{team.contestMatch.contest.name}}</div>
          </div>
          <div class="buttons">
            <div>
              <button class="clean box" @click="cancelCreateTeam">Cancel</button>
              <button
              class="clean fullcolor"
              @click="doCreateTeam"
              v-if="!saveState.isLoading()"
              :disabled="team.validTeam !== true">
                <span v-if="!team.isEdit()">Create Team</span>
                <span v-else>Save Team</span>
              </button>
              <loading-state :state="saveState"></loading-state>
            </div>
            <div class="info">
              <small v-if="team.validTeam !== true">{{team.validTeam}}</small>
            </div>
          </div>
        </div>

        <div class="selection wrap-on-mobile">
          <div class="rule">
            <div class="head">
              <div class="item">
                <b>{{team.rule.credits - team.creditUsed}}</b>
                <label>credits left of {{team.rule.credits}}</label>
              </div>
            </div>
            <h5>Rules</h5>
            <div class="rule-items">
              <ul>
                <li v-if="team.rule.max_players">
                  <span class="mark" :class="{success: team.isRulePassedPlayersCount()}"></span>
                  <label>Players:</label>
                  <b>{{team.playerKeys.length}}</b> of {{team.rangeLabel(team.rule.min_players, team.rule.max_players)}}
                </li>
                <template v-if="team.rule.max_players_per_team">
                  <template v-for="teamKey in ['a', 'b']">
                    <li :key="teamKey">
                      <span class="mark" :class="{success: team.teamsCount[teamKey] <= team.rule.max_players_per_team}"></span>
                      <label>{{team.match.teamShortName(teamKey)}} players:</label>
                      <b>{{team.teamsCount[teamKey]}}</b> of {{team.rule.max_players_per_team}}
                    </li>
                  </template>
                </template>
                <template v-if="team.rule.max_players_by_role">
                  <template v-for="(maxCount, role) in team.rule.max_players_by_role">
                    <li :key="role" v-if="maxCount || team.rule.min_players_by_role[role]">
                      <span class="mark" :class="{success: team.isRulePassedPlayersRoleCount(role)}"></span>
                      <label>{{role | capitalise}}:</label>
                      <b>{{team.rolesCount[role]}}</b> of {{team.rangeLabel(team.rolePlayerRange(role)[0], team.rolePlayerRange(role)[1])}}
                    </li>
                  </template>
                </template>
                <template v-if="team.rule.boost_names">
                  <template v-for="(playerKey, i) in team.selectedBoostPlayers()">
                    <li :key="i">
                      <span class="mark" :class="{success: playerKey !== null}"></span>
                      <label>{{team.rule.boost_names[i]}}:</label>
                      <b v-if="playerKey">{{team.playersState[playerKey].player.name}}</b>
                      <b v-else>No one</b>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
          </div>
          <div class="playersx">
            <template v-if="team.playerKeys.length > 0">
              <transition-group name="list" tag="div" class="players">
              <div
                class="player"
                v-for="playerKey in team.playerKeys"
                :key="playerKey"
              >
                <div class="credits">
                  <button class="remove-player black compact" @click="removePlayer(playerKey)">X</button>
                  <span class="fantasy-credit-value">{{team.playersState[playerKey].usedCredit}}</span>
                  {{team.playersState[playerKey].player.name}}
                </div>
                <div class="role">
                  <span>{{team.match.teamShortName(team.playersState[playerKey].team_key)}}</span>
                  <span>{{team.playersState[playerKey].player.fantasyRole.value | capitalise}}</span>
                </div>
                <div class="boost">
                  <span
                  v-if="team.playersState[playerKey].boostName"
                  @click="showBoostSelect(playerKey)"
                  class="clickable">
                    {{team.playersState[playerKey].boostName}}
                  </span>
                  <span v-else>
                    <button class="black compact" @click="showBoostSelect(playerKey)">⇮</button>
                  </span>
                </div>
              </div>
              </transition-group>
            </template>
            <div v-else>
              <div class="info">
                Please select players for your team from Fantasy Screen or from any player screen
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <app-dailog
      :show="boostDailogPayload.show"
      :showTitle="false"
      @onCancel="onBoostDailogCancel">
      <h5>{{boostDailogPayload.title}}</h5>
      <button
        v-for="(name, index) in team.rule.boost_names"
        :key="index"
        class="black"
        @click="onBoostSelected(index)">{{name}}</button>
    </app-dailog>
  </div>
</template>
<script>
import { AppState, DataState } from '@/state'
import AppEvents from '@/appevents'

export default {
  props: {
    team: Object,
  },
  data() {
    return {
      saveState: DataState.newNotInit(),
      state: DataState.newNotInit(),
      boostDailogPayload: {
        title: '',
        show: false,
        playerKey: null
      }
    }
  },
  // watch: {
  //   'team._ts'(to, from) {
  //     console.log('Update team', from, to)
  //   }
  // },
  mounted() {
    this.setupTeam()
  },
  methods: {
    setupTeam () {
      if (!this.team.playerCredits) {
        this.state.changeToLoading()
        this.team.match.fantasyCredits().then((credit) => {
          this.team.updatePlayerCredits(credit)
          this.state.changeToLoaded()
          this.onUIReady()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      } else {
        this.state.changeToLoaded()
        this.onUIReady()
      }
    },
    onUIReady () {
      // this._simulateUserAction()
    },

    cancelCreateTeam () {
      AppState.hideFantasyCreateTeam(this)
    },

    createDone (userTeam) {
        this.$globalEvents.$emit(AppEvents.fantasyCreateTeamDone, this.team.contestMatch, userTeam)
        AppState.hideFantasyCreateTeam(this)
    },

    participate (userTeam) {
      return this.team.contestMatch.participate(userTeam.key, this.team.rule.buy_in_chips).then((res)=>{
        this.$emit('participated', this.team.contestMatch, userTeam)
        this.$globalEvents.$emit(AppEvents.fantasyCreateTeamParticipated, this.team.contestMatch, userTeam)
        this.createDone(userTeam)
      })
    },

    doCreateTeam () {
      this.saveState.changeToLoading()
      const isEdit = this.team.isEdit()
      this.team.save().then((userTeam) => {
        this.$globalEvents.$emit(AppEvents.fantasyCreateTeamCreated, this.team.contestMatch, userTeam)
        if (!isEdit) {
          return this.participate(userTeam)
        }
        this.createDone(userTeam)
      }).then((res) => {
        this.saveState.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.saveState.changeToError(error)
      })
    },

    removePlayer (playerKey) {
      this.team.removePlayer(playerKey)
    },

    showBoostSelect (playerKey) {
      const playerName = this.team.playersState[playerKey].player.name
      const title = `Boost for ${playerName}`
      this.boostDailogPayload.title = title
      this.boostDailogPayload.playerKey = playerKey
      this.boostDailogPayload.show = true
    },

    onBoostDailogCancel () {
      this.boostDailogPayload.show = false
    },

    onBoostSelected (index) {
      const payload = this.boostDailogPayload
      this.team.addBoostPlayer(index, payload.playerKey)
      payload.show = false
    },

    _simulateUserAction () {
      if (this.team.playerKeys.length > 0) {
        return
      }

      const delay = (interval) => {
        return new Promise((resolve)=>{
          return setTimeout(resolve, interval)
        })
      }

      // const key = Object.keys(this.team.playersState)[0]
      const keys = ["s_dineshlad","ri_parag","m_vohra","an_roy","sh_singh","a_birla","j_buttler","my_markande","rah_chahar","rs_dar","b_sran"]
      delay(1000).then(()=>{
        keys.forEach((key, index)=> {
          const player = this.team.playersState[key]
          this.team.addPlayer(player.key, player.credit)
        })
        return delay(1000)
      }).then(()=>{
        // this.showBoostSelect(player.key)
        this.team.addBoostPlayer(0, keys[0])
        this.team.addBoostPlayer(1, keys[1])
      })
    },
  }
}
</script>
